module.exports = __webpack_public_path__ + "static/media/icon-5-01.a89dbe3b.png";